import { useCallback, useMemo } from 'react';

import { useCancelPlanTerminationModalStore, usePlanTerminationModalStore } from '../../store';
import { useGetPlanCoverageTerminationDataQuery } from '../queries/useGetPlanCoverageTerminationData.query';
import { useGetPlanTerminationPropertiesQuery } from '../queries/useGetPlanTerminationProperties.query';

import { usePlanTerminationCoverageDates } from './usePlanTerminationCoverageDates';

export const useCancelPlanTermination = () => {
  const planId = usePlanTerminationModalStore((state) => state.planId);
  const planName = usePlanTerminationModalStore((state) => state.planName);
  const isHsaAccount = usePlanTerminationModalStore((state) => state.isHsaAccount);
  const handleChangeVisibility = useCancelPlanTerminationModalStore((state) => state.handleChangeVisibility);
  const modalVisible = useCancelPlanTerminationModalStore((state) => state.modalVisible);
  const handleSetPlanId = usePlanTerminationModalStore((state) => state.handleSetPlanId);
  const handleSetPlanName = usePlanTerminationModalStore((state) => state.handleSetPlanName);
  const handleSetIsHsaAccount = usePlanTerminationModalStore((state) => state.handleSetIsHsaAccount);

  const { formattedData, isLoading: terminationDataLoading } = useGetPlanTerminationPropertiesQuery(modalVisible ? planId || '' : undefined);
  const currentTerminationDate = useMemo(() => {
    return formattedData?.terminationDate || '';
  }, [formattedData]);
  const { formattedData: coverages, isLoading: coveragesLoading } = useGetPlanCoverageTerminationDataQuery(planId, currentTerminationDate);

  const { coverageData, planData } = usePlanTerminationCoverageDates({
    planId,
    planName,
    endOfCoverage: formattedData?.coverageEndDate,
    lastDayToSubmitClaim: formattedData?.claimLastDate,
    planEndDate: coverages?.endDate,
    planStartDate: coverages?.startDate,
    viewMode: true,
  });

  const handleOpenCancelPlanTerminationModal = useCallback(
    (
      planId?: string,
      planName?: string,
      isHsaAccount?: boolean
    ) => {
    if (planId) handleSetPlanId(planId);
    if (planName) handleSetPlanName(planName);
    handleSetIsHsaAccount(isHsaAccount);
    handleChangeVisibility(true);
  }, [
    handleChangeVisibility,
    handleSetPlanId,
    handleSetPlanName,
    handleSetIsHsaAccount,
  ]);

  return {
    handleOpenCancelPlanTerminationModal,
    currentTerminationDate,
    coverageData,
    isHsaAccount,
    formattedData,
    terminationDataLoading: terminationDataLoading || coveragesLoading,
    planId,
    planName,
    planData,
  };
};
